import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './SelectAgentModal.scss';

export default class SelectAgentModal extends Component {
    static get propTypes() {
        return {
            responseId: PropTypes.number,
            isBuyer: PropTypes.bool,
            agentName: PropTypes.string,
            agentPhotoUrl: PropTypes.string,
            ltk: PropTypes.bool,
            ft: PropTypes.string,
            tracking: PropTypes.string
        };
    }

    componentDidMount() {
        trackEvent('proposal', 'selectAgent');
    }

    render() {
        const {responseId, isBuyer, agentName, agentPhotoUrl, ltk, ft, tracking} = this.props;

        return (
            <div className="modal nu-modal fade mobile-full-screen select-agent-modal">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="mt-7x modal-title">
                                {agentPhotoUrl &&
                                    <div className="mb-3x text-center agent-photo">
                                        <img src={agentPhotoUrl} onError={event => replaceImageOnError(event.target, 'img/profile-icon-l.jpg')}/>
                                    </div>
                                }
                                Congratulations!
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="mb-2x message">You selected <strong>{agentName}</strong>.</div>
                            <div className="mb-4x message">There is no obligation beyond this point until you sign a contract.</div>
                            <div className="mb-8x buttons">
                                <form method="POST" action={isBuyer ? 'markBuyWinner' : 'markWinner'}>
                                    <input type="hidden" name="quoteId" value={responseId}/>
                                    <input type="hidden" name="redirectToQuotes" value="true"/>
                                    <input type="submit" className="mb-2x btn btn-gray-outline" value="Keep other agents" onClick={() => {
                                                if(typeof UpNestAnalytics != 'undefined' && UpNestAnalytics != null) {
                                                    const sell_or_buy = this.props?.isBuyer ? 'buy' : 'sell';
                                                    UpNestAnalytics.trackEvent("click", {
                                                        pageId: "proposal",
                                                        linkName: 'keep_other_agents',
                                                        modalName: 'select_agent',
                                                        modalTrigger: `${sell_or_buy}:proposal:select_agent${this.props?.tracking}${this.props?.ltk ? '_ltk' : ''}${this.props?.ft ? '_ft' : ''}`,
                                                        pageType: "proposal",
                                                        siteSection: sell_or_buy,
                                                        rdcTrackingEnabled: "y",
                                                    });
                                                }
                                    }}/>
                                </form>
                                <form method="POST" action={isBuyer ? 'makeBuyWinner' : 'makeWinner'}>
                                    <input type="hidden" name="quoteId" value={responseId}/>
                                    <input type="hidden" name="redirectToQuotes" value="true"/>
                                    <input type="submit" className="mb-2x btn btn-default" value="Turn down other agents" onClick={() => {
                                        if(typeof UpNestAnalytics != 'undefined' && UpNestAnalytics != null) {
                                            const sell_or_buy = this.props?.isBuyer ? 'buy' : 'sell';
                                            UpNestAnalytics.trackEvent("click", {
                                                pageId: "proposal",
                                                linkName: 'turn_down_other_agents',
                                                modalName: 'select_agent',
                                                modalTrigger: `${sell_or_buy}:proposal:select_agent${this.props?.tracking == undefined ? "select_agent" : this.props.tracking}${this.props?.ltk ? '_ltk' : ''}${this.props?.ft ? '_ft' : ''}`,
                                                pageType: "proposal",
                                                siteSection: sell_or_buy,
                                                rdcTrackingEnabled: "y",
                                            });
                                        }
                                    }}/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
